// namespace velir.collections
var velir = velir || {};
velir.collections = velir.collections || {};

/**
* @class NameValueCollection constructor
* Basic implementation of a NameValueCollection class similar to the
* one available in C#. Primarily useful for building and manipulating 
* query strings. 
*/
velir.collections.NameValueCollection = function() {
	this._collection = {};
	this._keys = [];
}; 

/** 
* NameValueCollection prototype 
*/
(function() {

	//// Private functions ////

	/**
	* Combines the string values in the supplied array into a single
	* comma-separated string. Null values will be ignored.
	*/
	function combine(values) {
		var combined = "";
		for (var i = 0; i < values.length; i++) {
			var value = values[i];
			if (!value) {
				continue;
			}
			combined += value + ",";
		}
		return combined.length === 0 ? null : combined.substring(0, combined.length - 1);
	}

	//// public functions ////

	/**
	* Adds a new value to the collection for the specified name
	* 
	* @param key The name of the value. May be null.
	* @param value The value. If the value is null, the key will still be 
	* added to the collection, but the value will be blank when being converted 
	* to a query string, and will not be present when being combined with other 
	* values that share the same key. This mimics the behavior of the C# class.
	*/
	this.add = function(key, value) {
		var values = this._collection[key];
		if (!values) {
			values = [];
			this._keys.push(key);
		}
		if (value) {
			values.push(value);
		}
		this._collection[key] = values;
	};

	/**
	* Adds each key-value pair from the specified NameValueCollection to the 
	* current collection.
	*
	* @param nvc The NameValueCollection to be added.
	*/
	this.addNameValueCollection = function(nvc) {
		if (!nvc) {
			return;
		}
		var keys = nvc.getKeys();
		for (var i = 0; i < keys.length; i++) {
			var key = keys[i];
			var values = nvc.getValues(key);
			if (values && values.length > 0) {
				for (var j = 0; j < values.length; j++) {
					this.add(key, values[j]);
				}
			}
			else {
				this.add(key, null);
			}
		}
	};

	/**
	* Sets the value of a parameter in the collection. If the key already
	* existed, it's value will be overwritten.
	* 
	* @param key The name of the value. May be null.
	* @param value The value. If the value is null, the key will still be 
	* added to the collection, but the value will be blank when being converted 
	* to a query string, and will not be present when being combined with other 
	* values that share the same key. This mimics the behavior of the C# class.
	*/
	this.setValue = function(key, value) {
		var values = this._collection[key];
		if (!values) {
			this._keys.push(key);
		}
		var newValues = [];
		if (value) {
			newValues.push(value);
		}
		this._collection[key] = newValues;
	};

	/**
	* Removes all keys and values from the collection.
	*/
	this.clear = function() {
		this._collection = { };
		this._keys = [];
	};

	/**
	* Retrieves the value(s) for the specified name.
	* 
	* @param key The name of the the desired value
	* @returns The value for the specified name. If the name
	* has more than one value, the values will be returned in a 
	* comma-separated string.
	*/
	this.getValue = function(key) {
		if (!this._collection[key]) {
			return null;
		}
		var values = this._collection[key];
		var value = combine(values);
		return value;
	};

	/**
	* Retrieves the value(s) at the specified index. 
	* 
	* @param index The zero-based index of the the desired value
	* @returns The value at the specified index. If the name
	* has more than one value, the values will be returned as a 
	* comma-separated string.
	*/
	this.getValueAt = function(index) {
		return this.getValue(this._keys[index]);
	};

	/**
	* Retrieves the values at the specified index.
	* 
	* @param key The name of the desired value.
	* @returns An array of values for the specified name.
	*/
	this.getValues = function(key) {
		if (!this._collection[key]) {
			return null;
		}
		return this._collection[key];
	};

	/**
	* Retrieves the values at the specified index.
	* 
	* @param index The zero-based index of the the desired values.
	* @returns An array of values at the specified index.
	*/
	this.getValuesAt = function(index) {
		return this.getValues(this._keys[index]);
	};

	/**
	* Retrieves a list of names in the collection.
	* 
	* @returns An array of names in the collection.
	*/
	this.getKeys = function() {
		return this._keys;
	};

	/**
	* Removes the specified name and all associated values
	* from the collection.
	* 
	* @param key The name of the key to remove.
	*/
	this.remove = function(key) {
		//TODO: can we make this O(1)?
		var index = $.inArray(key, this._keys);
		if (index > -1) {
			this._keys.splice(index, 1);
		}
		this._collection[key] = null;
	};

	/**
	* Renders the name-value collection as a query string.
	* 
	* @returns The name-value collection rendered as a query string. Keys with
	* null values will be rendered as "key=" with no value. 
	*/
	this.toQueryString = function() {
		var queryString = "";
		for (var i = 0; i < this._keys.length; i++) {
			var key = this._keys[i];
			var value = this._collection[key];
			if (!value) {
				value = "";
			}
			queryString += "&" + key + "=" + escape(value);
		}
		if (queryString.length > 0) {
			return queryString.substring(1, queryString.length);
		}
		return queryString;
	};

	/**
	* Parses a query string an adds all key-value pairs.
	* 
	* @param queryString The query string to parse
	*/
	this.fromQueryString = function(queryString) {
		if (!queryString || queryString.length === 0) {
			return;
		}
		if (queryString.indexOf("?") > -1) {
			queryString = queryString.split("?")[1];
		}
		if (queryString.indexOf("#") > -1) {
			queryString = queryString.split("#")[0];
		}

		var keyValuePairs = queryString.split("&");
		for (var i = 0; i < keyValuePairs.length; i++) {
			var pair = keyValuePairs[i];
			var split = pair.split("=");
			var key = split[0];
			var value = null;
			if (split.length > 1) {
				value = unescape(split[1]);
			}
			this.add(key, value);
		}
	};

}).call(velir.collections.NameValueCollection.prototype);

//// Static members ////

/**
 * Parses a query string into a new NameValueCollection
 * 
 * @returns A new NameValueCollection containing the parsed query string.
 */
velir.collections.NameValueCollection.parseQueryString = function(queryString) {
	var qs = new velir.collections.NameValueCollection();
	qs.fromQueryString(queryString);
	return qs;
};// namespace velir.datacenter
var velir = velir || {};
velir.datacenter = velir.datacenter || {};

/**
* @class DatacenterContainer
* A container to hold information about Datacenter entities. If specified,
* the container will asynchromously retrieve information about the entity,
* such as its name, based on the IDs.
*/
velir.datacenter.DatacenterContainer = function() {

	// copy for closure
	var self = this;

	//// Private member functions ////
	this.addValuesToCollection = function(nameValueCollection, paramName, valueArray) {
		for (var i = 0; i < valueArray.length; i++) {
			var value = valueArray[i];
			nameValueCollection.add(paramName, value.id);
		}
	};

	this.getValuesFromCollection = function(nameValueCollection, paramName, valueArray, entityType, onLoadComplete) {
		var value = nameValueCollection.getValue(paramName);
		if (!value) {
			return;
		}
		var values = value.split(",");
		var name = "";
		if (velir.datacenter.DatacenterContainer.entitySearchService) {
			name = "Loading...";
		}
		$(values).each(function(index, id) {
			var obj = { id: "" + id, name: name };
			valueArray.push(obj);
		});

		if (velir.datacenter.DatacenterContainer.entitySearchService) {

			//only the ID is available in the query string, but we want to be able to display
			//name, types, etc as well, so query the web service to get that info
			var parms = JSON.stringify({
				ids: values
			});

			var serviceMethod = "/Find" + entityType + "s";

			$.ajax({
				type: "POST",
				url: velir.datacenter.DatacenterContainer.entitySearchService + serviceMethod,
				data: parms,
				contentType: "application/json; charset=utf-8",
				dataType: "json",
				error: function(XMLHttpRequest, textStatus, errorThrown) {
					alert("Error connecting to entity search service.\n\n" + textStatus);
				},
				success: function(result) {
					var resultArray = JSON.parse(result.d);

					for (var i = 0; i < resultArray.length; i++) {
						//replace the object in the valueArray with the result obj that matches the id
						var resultObj = resultArray[i];
						var index = -1;
						$(valueArray).each(function(j, obj) {
							if (obj.id == resultObj.id) {
								index = j;
								return false;
							}
						});
						if (index > -1) {
							valueArray.splice(index, 1, resultObj);
						}
					}

					if (onLoadComplete) {
						onLoadComplete();
					}
				}
			});
		}
		else {
			if (onLoadComplete) {
				onLoadComplete();
			}
		}
	};

	//// Public variables & methods ////
	var pub = {
		//// public variables ////

		// configuration
		/**
		* If set, entity names (and other information) will be loaded asynchronously via a 
		* web service call.
		*/
		loadEntityNames: false,

		/**
		* The path to the web service providing entity lookups
		*/
		entitySearchService: "",

		// entity lists
		indicators: [],
		timeFrames: [],
		dataFormatMaps: [],
		characteristics: [],
		locations: [],
		categories: [],
		overlays: [],

		//// public functions ////
		/**
		* Serializes the current configuration to a NameValueCollection suitable
		* for conversion a query string
		* 
		* @returns A NameValueCollection representing the entites in this container
		*/
		toNameValueCollection: function() {
			var urlParams = velir.datacenter.UrlParams;
			var qs = new velir.collections.NameValueCollection();
			self.addValuesToCollection(qs, urlParams.indicatorId, this.indicators);
			self.addValuesToCollection(qs, urlParams.timeFrameId, this.timeFrames);
			self.addValuesToCollection(qs, urlParams.dataFormatMapId, this.dataFormatMaps);
			self.addValuesToCollection(qs, urlParams.characteristicId, this.characteristics);
			self.addValuesToCollection(qs, urlParams.locationId, this.locations);
			self.addValuesToCollection(qs, urlParams.categoryId, this.categories);
			return qs;
		},

		/**
		* Serializes the current configuration to a query string
		*/
		toQueryString: function() {
			return this.toNameValueCollection().toQueryString();
		},

		/**
		* Parses configuration from a query string and fills out the container
		*
		* @param queryString The query string to parse
		* @param onLoadComplete A callback fired to indicate that the parsing and/or async loading 
		* of entities via a call to the web service has been completed depending on whether the 
		* "loadEntityNames" flag is set.
		*/
		fromQueryString: function(queryString, onLoadComplete) {
			var urlParams = velir.datacenter.UrlParams;
			var qs = velir.collections.NameValueCollection.parseQueryString(queryString);
			self.getValuesFromCollection(qs, urlParams.indicatorId, this.indicators, "Indicator", onLoadComplete);
			self.getValuesFromCollection(qs, urlParams.timeFrameId, this.timeFrames, "TimeFrame", onLoadComplete);
			self.getValuesFromCollection(qs, urlParams.dataFormatMapId, this.dataFormatMaps, "DataFormatMap", onLoadComplete);
			self.getValuesFromCollection(qs, urlParams.characteristicId, this.characteristics, "Characteristic", onLoadComplete);
			self.getValuesFromCollection(qs, urlParams.locationId, this.locations, "Location", onLoadComplete);
			self.getValuesFromCollection(qs, urlParams.categoryId, this.categories, "Category", onLoadComplete);
		}

	};

	return pub;
};

//// Static members ////

/**
 * Parses a query string into a new DataCenterContainer
 * 
 * @returns A new DatacenterContainer containing the parsed query string.
 */
velir.datacenter.DatacenterContainer.parseQueryString = function(queryString, onLoadComplete) {
	var container = new velir.datacenter.DatacenterContainer();
	container.fromQueryString(queryString, onLoadComplete);
	return container;
};

/**
* If set, entity names (and other information) will be loaded asynchronously via a 
* web service call to the service residing at the path specified here. Set to 
* false if async loading of entities is not desired.
*/
velir.datacenter.DatacenterContainer.entitySearchService = false;// namespace velir.datacenter
var velir = velir || {};
velir.datacenter = velir.datacenter || {};

/**
* @class UrlParams
* Defines various url parameter constants used by Datacenter
*/
velir.datacenter.UrlParams = {
	
	//// Static Variables ////

	// the params
	indicatorId: "ind",
	categoryId: "cat",
	locationId: "loc",
	locationTypeId: "loct",
	sourceId: "src",
	timeFrameId: "tf",
	dataFormatMapId: "fmt",
	characteristicId: "ch",

	//// Static methods ////

	/**
	* Given a type of DataCenter entity, returns the corresponding URL parameter
	*/
	getParameter: function(typeName) {
		var urlParams = velir.datacenter.UrlParams;
		switch (typeName.toLowerCase()) {
			case "indicator":
				return urlParams.indicatorId;
			case "category":
				return urlParams.categoryId;
			case "location":
				return urlParams.locationId;
			case "locationtype":
				return urlParams.locationTypeId;
			case "source":
				return urlParams.sourceId;
			case "timeframe":
				return urlParams.timeFrameId;
			case "dataformatmap":
				return urlParams.dataFormatMapId;
			case "characteristic":
				return urlParams.characteristicId;
		}
		return null;
	}
};
// namespace velir.util
var velir = velir || {};
velir.forms = velir.forms || {};

/**
* @class GhostText
* Static class that gives a text input box a 'ghost text' behavior. That is,
* some text (usually instructional, such as "Enter search terms") that initially appears 
* in the text box, but clears away when the box received focus.
*/
velir.forms.GhostText = {

    /**
    * Gives ghost text behavior to all the text input elements in the selection.
    *
    * @param selector A jQuery selector
    * @param text The ghost text to use for each text input
    * @param classToggle An optional CSS class name to toggle when the input is focused and blurred
    * @param onEnterPressed An optional callback to call when the Enter key is pressed in the text box
    */
    apply: function(selector, text, classToggle, onEnterPressed) {

        $(selector).each(function() {
            velir.forms.GhostText.applyTo($(this), text, classToggle, onEnterPressed);
        });
    },

    applyTo: function($e, text, classToggle, onEnterPressed) {
        if (!$e.is('input[type="text"]')) {
            return;
        }

        var isNullOrEmpty = velir.util.StringUtil.isNullOrEmpty;

        // only set the text if an initial value has not been set already
        if (isNullOrEmpty($e.val())) {
            $e.val(text);
        }

        $e.focus(function() {
            if ($(this).val() !== text) {
                return;
            }
            $(this).val('');
            if (!isNullOrEmpty(classToggle)) {
                $(this).toggleClass(classToggle);
            }
        });

        $e.blur(function() {
            if ($(this).val() !== '') {
                return;
            }
            $(this).val(text);
            if (!isNullOrEmpty(classToggle)) {
                $(this).toggleClass(classToggle);
            }
        });

        if (onEnterPressed !== null) {
            $e.keypress(function(e) {
                if (e.keyCode == 13) {
                    onEnterPressed(e);
                }
            });
        }
    },

    install: function(functionName) {
        $.fn[functionName] = function(text, classToggle, onEnterPressed) {
            return this.each(function() {
                velir.forms.GhostText.applyTo($(this), text, classToggle, onEnterPressed);
            });
        };
    }
};

// namespace velir.util
var velir = velir || {};
velir.util = velir.util || {};

/**
* @class DomUtil
* Static class with utility methods for DOM manipulation
*/
velir.util.DomUtil = {

	//// Static Methods ////

	/**
	* Scrolls the container element containing the specified element so that
	* the element is visible.
	*
	* @param element The element to be scrolled into view
	* @param container The scrollable element containing the element to be scrolled into view
	* @param padding The number of pixels of space to leave between the element that's being
	* scrolled into view and the edge of its container. Defaults to 4 if not specified.
	*/
	scrollElementIntoView: function(element, container, padding, animateFinishedCallback) {
		if (!element || !container) {
			return;
		}

		if (typeof (padding) == "undefined") {
			padding = 4; // Default to 4 pixels of padding
		}

		var $element = $(element);
		var $container = $(container);

		var $offsetParent = $element.offsetParent();
		if ($offsetParent.get(0) !== $container.get(0)) {
			// If the container's not visible, it's expected that it won't be calculated as the offset parent, so don't print the message
			if ($container.is(":visible")) {
				console.log("scrollElementIntoView: The specified container must be the offsetParent of the specified element. Try adding position:relative to the container.");
			}
			return;
		}

		// Is the element currently visible?
		var offset = $element.position().top;
		var visibleMin = $container.scrollTop();
		var elementHeight = $element.outerHeight();

		var duration = 200;
		if (offset < visibleMin) { // We need to scroll up
			// Put the element at the top with a couple pixels padding
			$container.stop().animate({ scrollTop: visibleMin + offset }, duration, animateFinishedCallback);

		}
		else if (offset > $container.innerHeight() - elementHeight - padding) { // Scroll down
			// Put the element at the bottom with a couple pixels padding
			var scrollTo = visibleMin + offset - $container.height() + elementHeight + padding;
			$container.stop().animate({ scrollTop: scrollTo }, duration, animateFinishedCallback);
		}
		else {
			// Just invoke the callback
			if (animateFinishedCallback) {
				animateFinishedCallback();
			}
		}
	}
};// namespace velir.util
var velir = velir || {};
velir.util = velir.util || {};

/**
* @class StringUtil
* Static class with utility methods for working with Strings
*/
velir.util.StringUtil = {

	//// Static Methods ////

	/**
	* Tests if the given string is null or an empty string
	*
	* @param str A string    
	*/
	isNullOrEmpty: function(str) {
		return str === null || str === undefined || str === '';
	},

	/**
	* Replaces indexed tokens in a string with text values.  Any
	* arguments passed to the format function after then string value
	* will be inserted into the indexed token.
	* @param str The string to format
	*/
	format: function(str) {
		var formatted = str;
		for (var i = 1; i < arguments.length; i++) {
			var regex = new RegExp('\\{' + (i - 1) + '\\}', 'gm');
			formatted = formatted.replace(regex, arguments[i]);
		}
		return formatted;
	}
};